import { ItemFilters, ValidItemStage } from '../../../Lib/Hooks/ItemService';
import { VPStages } from '../enums/stage.enums';

export type ItemStagesToVendorStages = {
  [K in ValidItemStage]: VPStages;
};

export const itemStagesToVendorStages: ItemStagesToVendorStages = {
  [ItemFilters.NEEDS_REVIEW]: VPStages.PENDING_FN,
  [ItemFilters.ACCEPTED]: VPStages.PENDING_FN,
  [ItemFilters.PENDING_VENDOR]: VPStages.NEEDS_DETAILS,
  [ItemFilters.PO_DRAFTS]: VPStages.DETAILS_SENT,
  [ItemFilters.MANAGER_REVIEW]: VPStages.DETAILS_SENT,
  [ItemFilters.FINAL_REVIEW]: VPStages.DETAILS_SENT,
  [ItemFilters.PO_CREATED]: VPStages.PO_CREATED,
  [ItemFilters.REJECTED]: VPStages.PASSED,
};
